// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___8f083d05595a4672c62","cls2":"Header-cls2__d0faffb87f9391392707 Header-cls1___8f083d05595a4672c62"};